
































































































































import Vue from "vue";

// Components
import DateTimeRangePicker from "@/components/DateTimeRangePicker.vue";
import DeviceTree from "@/components/DeviceTree/index.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetBranchesCommand } from "@/model/communication/branch/GetBranchesCommand";
import { GetBranchesResData } from "@/model/communication/branch/GetBranchesResData";
import { GetUsersBalanceReportReqData } from "@/model/communication/usersBalance/GetUsersBalanceReportReqData";
import { CaosGroup } from "@/model/communication/usersBalance/GetUsersBalanceReportResData";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";

export default Vue.extend({
    components: {
        DeviceTree,
        DateTimeRangePicker,
    },
    data() {
        return {
            radioGroup: 1,
            availableBranches: null,
            selectedBranch: -1,
            selectedInstallationNames: null,
            rerender: 0,
            deviceTreeSelectedObjectItems: [],
            ignoreSelectedInstallationNames: false,
            dateFilterTypes: [
                {
                    text: this.$t("common.dateTime"),
                    value: 0,
                },
                {
                    text: this.$t("common.accounting_date"),
                    value: 1,
                },
            ],
            dateFilterType: 0,
            selectedGroupIds: [],
            selectedShiftNumbers: [],
            selectedCurrency: null,
        };
    },
    props: {
        value: {},
        availableGroups: {},
        showGroupsFilter: { type: Boolean, default: false },
        availableShiftNumbers: { type: Array },
        availableCurrencies: { type: Array },
        showShiftNumbersFilter: { type: Boolean, default: false },
        showCurrencyFilter: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    computed: {
        availableGroupsComputed() {
            if (this.availableGroups != null && this.availableGroups.length > 0) return this.availableGroups.map((group: CaosGroup) => ({ value: group.id, text: group.name }));
            else return null;
        },
    },
    watch: {
        radioGroup() {
            this.selectedBranch = null;
            this.selectedInstallationNames = [];
        },
        dateFilterType() {
            var temp = new GetUsersBalanceReportReqData();
            (this.value.startDate as Date) = temp.startDate;
            (this.value.endDate as Date) = temp.endDate;
        },
        selectedBranch(newValue) {
            this.value.branchId = newValue != null ? newValue : -1;
        },
        selectedGroupIds(newValue) {
            if (newValue != null) {
                this.value.userGroupIds = [];
                newValue.forEach((element) => {
                    this.value.userGroupIds.push(element);
                });
                this.value.userGroupIds.sort();
            }
        },
        selectedShiftNumbers(newValue) {
            if (newValue != null) {
                this.value.shiftNumbers = [];
                newValue.forEach((element) => {
                    this.value.shiftNumbers.push(element);
                });
                this.value.shiftNumbers.sort();
            }
        },
        availableCurrencies() {
            if (this.showCurrencyFilter && this.availableCurrencies != null && this.availableCurrencies.length > 0) this.selectedCurrency = this.availableCurrencies[0];
        },
        selectedCurrency(newValue) {
            this.value.currency = newValue;
        },
        deviceTreeSelectedObjectItems(newValue) {
            this.selectedInstallationNames = null;
            if (newValue) {
                if (newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > 0) {
                    this.ignoreSelectedInstallationNames = true;
                    this.selectedInstallationNames = newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                }
            }
        },
        selectedInstallationNames(newValue) {
            if (!this.ignoreSelectedInstallationNames) {
                if (newValue && this.deviceTreeSelectedObjectItems != null) {
                    this.rerender += 1;
                    this.deviceTreeSelectedObjectItems = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device && newValue.indexOf(c.id) >= 0);
                }
            } else this.ignoreSelectedInstallationNames = false;

            this.value.installationNames = [];
            if (newValue != null && newValue.length > 0) {
                newValue.forEach((installationName) => {
                    this.value.installationNames.push(installationName);
                });
            }
            this.value.installationNames.sort();
        },
    },
    methods: {
        async GetAvailableBranches() {
            try {
                var res: GetBranchesResData = await new GetBranchesCommand().execute();

                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    if (res.availableBranches != null && res.availableBranches.length > 0) {
                        this.availableBranches = res.availableBranches.map((val) => ({ value: val.id, text: val.name }));
                    }
                }
            } catch (error) {
                console.error("GetAvailableBranches(): ", error);
            }
        },

        onSubmit() {
            this.value.isAccountingDateFilterEnabled = this.dateFilterType == 1;
            this.$emit("submit");
        },
    },
    mounted() {
        this.GetAvailableBranches();
        if (this.showCurrencyFilter && this.availableCurrencies != null && this.availableCurrencies.length > 0) this.selectedCurrency = this.availableCurrencies[0];
    },
});
